import { useInfiniteQuery } from '@tanstack/react-query';

import type { GetMeetingsParams } from './meetingService';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function useGetAssignedMeetingsInfinite(params: GetMeetingsParams) {
  return useInfiniteQuery({
    queryKey: [MeetingKey.MEETINGS_INFINITE, params],
    queryFn: ({ pageParam }) => {
      return MeetingService.getAssignedMeetings(pageParam).then((response) => response.data);
    },
    initialPageParam: {
      page: 0,
      pageSize: 20,
      name: undefined,
      sortOrder: 'ASC' as const,
      ...params,
    },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
